import { api } from './client'

export type MarcaNaLista = {
  id: number
  chave: string
  nome: string
  telefone: string | null
  ativa: boolean

  /** Quantos canais a marca tem. O back não devolve contagem de assistentes. */
  caixas: number
}

export type PedidoDeMarca = {
  nome: string
  telefone: string | null
  ativa: boolean
}

/**
 * Marcas do grupo.
 *
 * 🔴 A **chave é derivada do nome e não muda na alteração** — ela está em URL,
 * em vínculo de caixa e em orçamento gravado. Renomear a marca é operação de
 * rótulo; trocar a chave seria quebrar referência.
 *
 * Não há exclusão: apagar marca com conversa vinculada é decisão de retenção
 * (`PRI-LGPD-02`), não de cadastro. Desativar basta.
 */
export const marcas = {
  listar: () => api.get<MarcaNaLista[]>('/marcas'),

  criar: (pedido: PedidoDeMarca) =>
    api.post<{ id: number; chave: string; nome: string }>('/marcas', {
      ...pedido,
      chave: null,
    }),

  alterar: (chave: string, pedido: PedidoDeMarca) =>
    api.put<{ id: number; chave: string; nome: string }>(`/marcas/${chave}`, pedido),
}
